module.exports = {
  features: {
    pricing: {
      taxCode: false
    }
  }
}
